import * as R from 'ramda'
import type {RouteComponentProps} from 'react-router-dom'

export const isolateRouteComponentProps = <
  DynamicPathPieces extends {[K in keyof DynamicPathPieces]?: string},
>(
  props: RouteComponentProps<DynamicPathPieces>
): RouteComponentProps<DynamicPathPieces> => {
  return R.pick(['history', 'match', 'location', 'staticContext'], props)
}
